import React from "react";
import { useLocalization } from "@fluent/react";
import type { DataAccessConsent } from "./types";
import styles from "./ThirdPartyDataAccess.module.scss";

interface ConnectionItemProps {
  connection: DataAccessConsent;
  onRevoke: (connection: DataAccessConsent) => void;
}

const ConnectionItem = ({
  connection,
  onRevoke,
}: ConnectionItemProps) => {
  const { l10n } = useLocalization();

  const connectedDate = new Date(connection.connected_at).toLocaleDateString(
    "en-US",
    { month: "2-digit", day: "2-digit", year: "2-digit" }
  );

  return (
    <div className={styles["connection-card"]}>
      <div className={styles["connection-item"]}>
        <div className={styles["connection-info"]}>
          <div>
            <p className={styles["connection-name"]}>
              {connection.application_name}
              {connection.data_partner &&
                ` (via ${connection.data_partner.charAt(0).toUpperCase() + connection.data_partner.slice(1)})`}
            </p>
            <p className={styles["connection-date"]}>
              {l10n.getString("label-connected-on", { date: connectedDate })}
            </p>
          </div>
        </div>
        <div>
          <button
            type="button"
            className={styles["revoke-link-button"]}
            onClick={() => onRevoke(connection)}
            data-testid={`revoke-connection-${connection.id}`}
          >
            {l10n.getString("button-revoke")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConnectionItem;
